import { render, staticRenderFns } from "./FastOrdersCreateAdmin.vue?vue&type=template&id=2bdc4be1&scoped=true"
import script from "./FastOrdersCreateAdmin.vue?vue&type=script&lang=js"
export * from "./FastOrdersCreateAdmin.vue?vue&type=script&lang=js"
import style0 from "./FastOrdersCreateAdmin.vue?vue&type=style&index=0&id=2bdc4be1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdc4be1",
  null
  
)

export default component.exports